import Cookies from 'js-cookie';

export const saveDomain = (domain: string): void => {
  localStorage.setItem('domain', domain);
  Cookies.set('domain', domain, { expires: 7, domain: 'localhost' });
};

export const removeDomain = (): void => {
  localStorage.removeItem('domain');
  Cookies.remove('domain', { domain: 'localhost' });
};
